module.exports = __webpack_public_path__ + "static/media/guanyinshan1.76a4b90f.jpg";